import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { esimApi } from './esimApi';

class ESIMMyPlanDetail extends Component {
    state = {
        fallbackPlan: {
            id: 1,
            countryKey: '',
            country: '',
            flag: '',
            status: '',
            statusLabel: '',
            remainingGb: null,
            usedMb: null,
            totalMb: null,
            activatedAt: '',
            expiresAt: '',
            duration: '',
            price: '',
            features: []
        },
        helpInfo: {
            title: '',
            description: '',
        },
        plan: null,
        usage: null,
        isLoading: false
    }

    getPlanStatusAndAction = (item) => {
        const displayState = (item.displayState || '').toUpperCase();
        const dataMbUsed = item.dataMbUsed ?? Math.max((item.dataMbTotal ?? 0) - (item.dataMbRemaining ?? 0), 0);
        const canTopUp = Boolean(item.canTopUp);
        const depleted = Boolean(item.depleted);

        if (displayState === 'ACTIVE') {
            return {
                status: 'pending',
                statusLabel: 'Gözləmədə',
                primaryAction: 'Setup'
            };
        }

        if (displayState === 'IN_USE') {
            return {
                status: 'active',
                statusLabel: 'Aktiv',
                primaryAction: canTopUp || depleted ? 'Top Up' : null
            };
        }

        if (displayState === 'EXPIRED') {
            return {
                status: 'expired',
                statusLabel: 'Müddəti bitmiş',
                primaryAction: 'Reinstall'
            };
        }

        if (displayState === 'CANCELLED') {
            return {
                status: 'expired',
                statusLabel: 'Ləğv edilmiş',
                primaryAction: 'Reinstall'
            };
        }

        const fallbackStatus = (item.status || '').toLowerCase();
        return {
            status: fallbackStatus || 'active',
            statusLabel: item.displayState || '',
            primaryAction: fallbackStatus === 'pending' ? 'Setup' : fallbackStatus === 'expired' ? 'Reinstall' : 'Top Up'
        };
    }

    getPlan = () => {
        const { plan } = this.state;
        const statePlan = this.props.location.state?.plan;
        const { fallbackPlan } = this.state;

        if (plan) {
            return plan;
        }

        if (!statePlan) {
            return fallbackPlan;
        }

        const mappedState = this.getPlanStatusAndAction(statePlan);
        return {
            ...fallbackPlan,
            ...statePlan,
            status: mappedState.status,
            statusLabel: mappedState.statusLabel || statePlan.statusLabel,
            primaryAction: statePlan.primaryAction || mappedState.primaryAction,
            usedMb: typeof statePlan.usedMb === 'number' ? statePlan.usedMb : (statePlan.totalMb || fallbackPlan.totalMb) - (statePlan.remainingGb || fallbackPlan.remainingGb)
        };
    }

    openSetup = (plan) => {
        this.props.history.push({
            pathname: `/dashboard/services/e-sim/setup/${encodeURIComponent(plan.countryKey || plan.country)}/${plan.id || 1}`,
            state: {
                selectedCountry: { name: plan.country, flag: plan.flag },
                selectedPlan: { id: plan.id || 1, volume: `${plan.totalMb} GB` }
            }
        });
    }

    handlePrimaryAction = (plan) => {
        if (plan.primaryAction === 'Setup') {
            this.openSetup(plan);
            return;
        }

        if (plan.primaryAction === 'Top Up' || plan.primaryAction === 'Reinstall') {
            this.props.history.push(`/dashboard/services/e-sim/details/${encodeURIComponent(plan.countryKey || plan.country)}`);
        }
    }

    componentDidMount = () => {
        this.loadPlan();
    }

    loadPlan = async () => {
        const planId = this.props.match.params.id || this.props.location.state?.plan?.id;

        if (!planId) {
            return;
        }

        this.setState({ isLoading: true });

        try {
            const [planResponse] = await Promise.all([
                esimApi.getEsim(planId),
                // esimApi.getEsimUsage(planId)
            ]);

            const apiPlan = planResponse?.data || null;
            // const apiUsage = usageResponse?.usage || usageResponse?.data || usageResponse || null;
            const mappedState = this.getPlanStatusAndAction(apiPlan || {});

            this.setState({
                plan: apiPlan ? {
                    id: apiPlan.esimId || null,
                    countryKey: apiPlan.countryCode || apiPlan.destinationCode || apiPlan.country || 'Turkey',
                    country: apiPlan.destinationName || '',
                    flag: apiPlan.flagUrl || '🌍',
                    status: mappedState.status,
                    statusLabel: mappedState.statusLabel,
                    remainingMb: apiPlan.dataMbRemaining ?? 0,
                    usedMb: apiPlan.dataMbUsed ?? 0,
                    totalMb: apiPlan.dataMbTotal ?? 0,
                    depleted: Boolean(apiPlan.depleted),
                    canTopUp: Boolean(apiPlan.canTopUp),
                    activatedAt: apiPlan.validFrom || '—',
                    expiresAt: apiPlan.validTo || '—',
                    duration: apiPlan.duration || apiPlan.durationLabel || '—',
                    price: apiPlan.price ? `${apiPlan.price} ${apiPlan.currency || ''}`.trim() : '—',
                    features: apiPlan.features || apiPlan.tags || [],
                    primaryAction: mappedState.primaryAction
                } : null,
                // usage: apiUsage,
                isLoading: false
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const plan = this.getPlan();
        const { isLoading } = this.state;

        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{this.props.t('eSIMlərim')}</h2>
                    </div>
                </div>

                <div className="dashboard-account-body">
                    <div className="m-3" style={{ marginTop: '1px' }}>
                        <div className="dashboard-esim-my-layout">
                            <div className="dashboard-esim-my-main">
                                <div className="dashboard-esim-my-detail-country">
                                    {plan.flag && String(plan.flag).indexOf('http') === 0
                                        ? <img src={plan.flag} alt={plan.country} width="36" height="28" />
                                        : plan.flag}
                                    <h3>{plan.country}{isLoading ? '...' : ''}</h3>
                                </div>

                                <div className="dashboard-esim-my-detail-content">
                                    <div className="dashboard-esim-my-detail-left-card">
                                        <div className="dashboard-esim-my-circle">
                                            <div className="dashboard-esim-my-circle-inner">
                                                <strong>{plan.remainingMb} MB</strong>
                                                <span>{this.props.t('Remaining')}</span>
                                                <small>• {plan.statusLabel}</small>
                                            </div>
                                        </div>

                                        <div className="dashboard-esim-my-stats-row">
                                            <div>
                                                <strong>{plan.usedMb} MB</strong>
                                                <span>{this.props.t('Used')}</span>
                                            </div>
                                            <div>
                                                <strong>{plan.totalMb} MB</strong>
                                                <span>{this.props.t('Total')}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="dashboard-esim-my-detail-right">
                                        <div className="dashboard-esim-my-detail-plan-card">
                                            <h4>{this.props.t('Plan detalları')}</h4>
                                            <div><span>{this.props.t('Aktivləşdirilmə tarixi')}</span><strong>{plan.activatedAt}</strong></div>
                                            <div><span>{this.props.t('Son tarix')}</span><strong>{plan.expiresAt}</strong></div>
                                            <div><span>{this.props.t('Müddət')}</span><strong>{plan.duration}</strong></div>
                                            <div><span>{this.props.t('Qiymət')}</span><strong>{plan.price}</strong></div>
                                        </div>

                                        <div className="dashboard-esim-my-feature-tags">
                                            {plan.features.map((feature) => (
                                                <span key={feature}>◉ {feature}</span>
                                            ))}
                                        </div>

                                        {plan.primaryAction ? (
                                            <button type="button" className="dashboard-esim-my-install-btn" onClick={() => this.handlePrimaryAction(plan)}>
                                                {plan.primaryAction}
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            {/* <aside className="dashboard-esim-my-side">
                                <h4>{helpInfo.title}</h4>
                                <div className="dashboard-esim-my-side-illustration" aria-hidden="true" />
                                <p>{helpInfo.description}</p>
                            </aside> */}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default translate('translation')(ESIMMyPlanDetail);